export enum State {
  Green = 'green',
  Yellow = 'yellow',
  Red = 'red',
  Gray = 'gray',
  Default = 'gray'
}

export enum DisconnectRule {
  CloudSoftware = 'CLOUD_SOFTWARE',
  RealTime = 'REAL_TIME',
  Default = 'DEFAULT'
}

export const maintenanceDue = 'maintenance_due'
